import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, makeStyles } from '@material-ui/core';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  section: {
    backgroundColor: theme.customPalette.secondaryBlueB02,
    padding: '18px 0',
  },
  box: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
  },
  boxContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '5px',
    color: 'white',
  },
  message: { color: 'white', fontSize: '14px' },
  icon: { color: 'white', cursor: 'pointer' },
}));

const InfoBanner = ({ message, onClose }) => {
  const classes = useStyles();

  return (
    <Box className={classes.section}>
      <Container>
        <Box className={classes.box}>
          <div className={classes.boxContent}>
            <InfoOutlined fontSize="medium" />
            <span className={classes.message}>{message}</span>
          </div>
          {onClose && (
            <CloseIcon
              fontSize="small"
              className={classes.icon}
              onClick={onClose}
            />
          )}
        </Box>
      </Container>
    </Box>
  );
};

InfoBanner.propTypes = {
  message: PropTypes.string,
  show: PropTypes.bool,
  severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  onClose: PropTypes.func,
};

export default InfoBanner;
